export { default } from './FiftyFifty'
